/**
 * Public HTTPS origin used for Stripe success/cancel URLs from the native
 * apps. The web client returns to its own origin.
 */
export const PUBLIC_WEB_ORIGIN = 'https://www.novaadulthockey.com'

export function checkoutAppOrigin (): string {
  const origin = typeof window !== 'undefined' ? window.location.origin : PUBLIC_WEB_ORIGIN
  const base = String(import.meta.env.BASE_URL || '/').replace(/\/$/, '')
  return `${origin}${base}`
}

/** Absolute URL for a same-app path (must start with /). */
export function checkoutReturnUrl (pathAndQuery: string): string {
  const path = pathAndQuery.startsWith('/') ? pathAndQuery : `/${pathAndQuery}`
  return `${checkoutAppOrigin()}${path}`
}

/** Open Stripe Checkout with a full-page redirect. */
export async function openStripeCheckout (url: string): Promise<void> {
  if (!url) throw new Error('No checkout URL')
  window.location.assign(url)
}
